import { Box, Flex } from "@chakra-ui/react";
import TransactionsViewsSidebar from "features/transactions/TransactionsViewsSidebar/TransactionViewsSidebar";
import { Outlet } from "react-router";
import { QueryBoundary } from "shared/api/QueryBoundary";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import PageSidebar from "shared/components/layout/PageSidebar";

const TransactionLayout: React.FC = () => (
  <PageContainer>
    <PageContent contentWidth="full-width" isFullHeight={true}>
      <Flex height="100%">
        <PageSidebar width={325}>
          <Box id="transaction-layout-sidebar" height="100%" bg="white">
            <Box height="100%" overflow="auto">
              <TransactionsViewsSidebar />
            </Box>
          </Box>
        </PageSidebar>
        <Box height="100%" flex={1}>
          <Box height="100%" overflow="auto">
            <QueryBoundary>
              <Outlet />
            </QueryBoundary>
          </Box>
        </Box>
      </Flex>
    </PageContent>
  </PageContainer>
);
export default TransactionLayout;
